export const initialState = {
    leasingFinancialProductXWarrantyId: null,
    productId: null,
    warrantyTypeId: null,
    warrantyTypeName: "",
    quantity: 0,
    quantityTypeId: null,
    quantityTypeName: "",
    mandatory: false,
    genericFilterTemplateId: null,
    templateName: null,
    changed: false,
    saving: false
  };


  
export function reducer(state, action) {
    switch (action.type) {
      case 'OnInitState':
        return onInitState(state, action);
      case 'OnAdded':
        return onAdded(state, action);
      case 'OnHeaderPropertyChanged':
        return onHeaderPropertyChanged(state, action);
      case 'OnHeaderSaved':
        return onHeaderSaved(state, action);
      case 'OnHeaderSaveStarted':
        return onHeaderSaveStarted(state, action);
      default:
        return state;
    }
  }
  
  function onInitState(state, action) {
    const { ...financialProductWarranty } = action.data;
    return {
      ...state,
      ...financialProductWarranty
    };
  }
  
  function onAdded(state, action) {
    return {
      ...state,
      productId: action.productId
    };
  }
  
  function onHeaderPropertyChanged(state, action) {
    const { propertyName, value } = action;
    return {
      ...state,
      [propertyName]: value,
      changed: true
    };
  }
  
  function onHeaderSaved(state) {
    return {
      ...state,
      changed: false,
      saving: false
    };
  }
  
  const onHeaderSaveStarted = state => {
    return {
      ...state,
      saving: true
    };
  };
  